// extracted by mini-css-extract-plugin
export default {"mainContainer":"Autopilot_mainContainer__1JdWa","autopilotContainer":"Autopilot_autopilotContainer__4IoX7","textContainer":"Autopilot_textContainer__fNQsp"};